import { withDatasourceCheck } from '@sitecore-jss/sitecore-jss-nextjs';
import { useSitecoreContext } from '@sitecore-jss/sitecore-jss-react';

import {
  AppHeader,
  ComponentProps,
  HeaderFields,
  HeaderProvider,
  useSiteSettings,
} from '@gn-audio/jss-components';

import { CondensedMenuComponent } from 'common/condensedMenu/CondensedMenuComponent';
import { useCondensedMenu } from 'common/condensedMenu/CondensedMenuProvider';

type HeaderProps = ComponentProps & {
  fields: HeaderFields;
};

const Header = ({ fields }: HeaderProps): React.JSX.Element | null => {
  const {
    sitecoreContext: { route, language },
  } = useSitecoreContext();
  const { myjabra } = useSiteSettings();
  const { showMenu, menuItems } = useCondensedMenu();
  return (
    <HeaderProvider
      currentLocale={language}
      route={route}
      myJabraUrl={myjabra?.baseUrl}
      fields={fields}
    >
      <AppHeader
        condensedMenu={showMenu || menuItems.length ? <CondensedMenuComponent /> : undefined}
      />
    </HeaderProvider>
  );
};

export default withDatasourceCheck()<HeaderProps>(Header);
